import React, { useState, useRef, useEffect } from "react";
import { Button } from "reactstrap";
import Player from "./react-hls-player";
const Index = ({ url, autoplay }) => {
  const [hlsUrl, sethlsUrl] = useState(url);
  const [destroy, setdestroy] = useState(false);

  const handleDestroyClick = () => {
    setdestroy(true);
  };
  const playerRef = useRef();
  useEffect(() => playerRef.current && playerRef.current.focus());

  const handleToggleControls = () => {
    try {
      if (playerRef.current.hasAttribute("controls")) {
        playerRef.current.removeAttribute("controls");
      } else {
        playerRef.current.setAttribute("controls", true);
      }
    } catch {}
  };

  const handleEnter = (e) => {
    if (e.keyCode === 13) {
      sethlsUrl(e.target.value);
    }
  };

  return (
    <>
      <Player
        loop={true}
        autoplay={autoplay}
        width="100%"
        height="auto"
        playerRef={playerRef}
        url={hlsUrl}
      />

      {/* {!destroy ? (
        <Player      
          loop={true}     
          width="100%"
          height="auto"
          playerRef={playerRef}
          url={hlsUrl}
        />
      ) : <Player
      loop={true}     
      width="100%"
      height="auto"
      autoplay ={false}  
      playerRef={playerRef}
      url={hlsUrl}
    />} */}

      <br />

      {/* <Button className="m-1" color="danger"
        style={{
          padding: "5px 10px",
        }}
        onClick={handleDestroyClick}
      >
        ตัดการเชื่อมต่อ
      </Button> */}

      {/* <Button className="m-1" 
        style={{
          padding: "5px 10px",
        }}
        onClick={handleToggleControls}
      >
       โชว์สถานะเพื่อเล่น
      </Button> */}
    </>
  );
};

export default Index;
